import { ViewportScroller } from '@angular/common';
import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { Subject, Subscription, timer } from 'rxjs';
import { AirdiskbrakeService } from 'src/app/services/feature/airdisk-brake/airdiskbrake.service';

@Component({
  selector: 'app-airdisk-email',
  templateUrl: './airdisk-email.component.html',
  styleUrls: ['./airdisk-email.component.scss'],
  standalone: false
})
export class AirdiskEmailComponent {
  captchaResolved: boolean = false;
  subscription = new Subscription();
  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID
  constructor(public airdiskService: AirdiskbrakeService,
    public dialogRef: MatDialogRef<AirdiskEmailComponent>,
    private readonly globalmsgService: GlobalMessageService,
    private readonly viewPortScroller: ViewportScroller
  ) { }
  emailForm = new FormGroup({
    FName: new FormControl(null, { validators: Validators.required }),
    LName: new FormControl(null, { validators: Validators.required }),
    emailId: new FormControl(null, { validators: Validators.required }),
    recaptcha: new FormControl(null, [Validators.required]),
  });
  get form() {
    return this.emailForm.controls;
  }
  ngOnInit() {
    this.subscription = this.airdiskService.vistInfoData$.subscribe(data => {
      console.log(data);
      if (data != null) {
        this.emailForm.patchValue({
          FName: data.firstName || null,
          LName: data.lastName || null,
          emailId: data.eMail || null,
        });
      }
    })
    setTimeout(() => { document.querySelector('.cdk-global-overlay-wrapper')?.removeAttribute('popover') }, 0);
  }

  emailResult() {
    if (this.emailForm.valid) {
      this.airdiskService.popUpData$.next(this.emailForm.value);
      this.airdiskService.postAPI().subscribe((x: any) => {
        if (x === 'Success') {
          this.dialogRef.close({
            status: 'Success',
            message: 'common.airdiscBrake_value_calculator_formSubmit_success'
          });
        }
      });
    }
    else {
      this.emailForm.markAllAsTouched();
    }
  }

  checkCaptcha(captchaResponse: string) {
    this.captchaResolved = !!(captchaResponse && captchaResponse.length > 0);
  }
  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.subscription.unsubscribe();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}
